import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import StyledDialog from '../../../shared/StyledDialog'
import { useAdvisorUserDetails } from '../../AdvisorUserFormContext'

const ResetUserDialog = forwardRef(function ResetUserDialog ({ onConfirm, processing }, ref) {
  const { user } = useAdvisorUserDetails()

  return (
    <StyledDialog
      ref={ref}
      confirmText='Reset User'
      onConfirm={onConfirm}
      title='Reset User'
      size='sm'
      processing={processing}
    >
      Are you sure you want to reset {user.firstName} {user.lastName} ({user.email})?
    </StyledDialog>
  )
})

ResetUserDialog.propTypes = {
  onConfirm: PropTypes.func,
  processing: PropTypes.bool
}

ResetUserDialog.defaultProps = {
  processing: false
}

export default ResetUserDialog
